<section id="success">
  <div class="card cart-success">
    <div class="header"></div>
    <div class="body">
      <h1>Success</h1>
      <div class="subtitle">We’re preparing your order for liftoff 🚀</div>
      <div class="thank-you">
        Thank you for your purchase! You will receive a confirmation email in your inbox in a few minutes. Here are the details of your order:
      </div>
      <div *ngIf="order?.items">
        <div class="order-item" *ngFor="let item of features">
          <div class="row">
            <div class="col col-3">
              <div class="book">Book</div>
            </div>
            <div class="col col-9">
              <div class="flex line-content">
                <img class="book-cover" [src]="item._book.amazonImageUrl 
                ? item._book.amazonImageUrl : '../../../../assets/img/defaults/default_book_image_400w_simple.jpg'"/>
                <div>{{ item._book.title}}</div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="row">
            <div class="col col-3">
              <div class="promotion">Promotion</div>
            </div>
            <div class="col col-9">
              <div class="flex line-content">
                <img class="site-image" [src]="item._site.logoURL" />
                <div>{{ item._siteAdvert.name}}</div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="row">
            <div class="col col-3">Price</div>
            <div class="col col-9 line-content">
              {{ item.paymentAmount | currency:'USD':true:'1.2-2'}}
            </div>
            <div class="clear"></div>
          </div>
          <div class="row">
            <div class="col col-3">Start Date</div>
            <div class="col col-9 line-content">
              {{ item.pubDate }}
            </div>
            <div class="clear"></div>
          </div>
        </div>
          <!-- PROMO STACKS -->
        <div class="order-item" *ngFor="let item of promostacks">
            <div class="row">
              <div class="col col-3">
                <div class="book">Book</div>
              </div>
              <div class="col col-9">
                <div class="flex line-content">
                  <img class="book-cover" [src]="item._book.amazonImageUrl" />
                  <div>{{ item._book.title}}</div>
                </div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="row">
              <div class="col col-3">
                <div class="promotion">Promo Stack</div>
              </div>
              <div class="col col-9">
                <div class="flex line-content">
                  {{ item._promoStack.name}}
                </div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="row">
              <div class="col col-3">Price</div>
              <div class="col col-9 line-content">
                {{ item.paymentAmount | currency:'USD':true:'1.2-2'}}
              </div>
              <div class="clear"></div>
            </div>
            <div class="row">
              <div class="col col-3">Start Date</div>
              <div class="col col-9 line-content">
                {{ item.startDate }}
              </div>
              <div class="clear"></div>
            </div>
        </div>
        <!-- EVENTS -->
        <div class="order-item" *ngFor="let item of events">
            <img class="event-image" [src]="item.image" />
            <div class="row">
              <div class="col col-3">
                Event
              </div>
              <div class="col col-9">
                <div class="flex line-content">
                  {{ item.name }}
                </div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="row">
              <div class="col col-3">Date</div>
              <div class="col col-9 line-content">
                {{ item.date }}
              </div>
              <div class="clear"></div>
            </div>
            <div class="row">
              <div class="col col-3">Registrant</div>
              <div class="col col-9 line-content">
                {{ item.attendeeName }} ({{ item.attendeeEmail }})
              </div>
              <div class="clear"></div>
            </div>
            <div class="row">
              <div class="col col-3">Price</div>
              <div class="col col-9 line-content">
                {{ item.paymentAmount | currency:'USD':true:'1.2-2'}}
              </div>
              <div class="clear"></div>
            </div>
            
        </div>
        <!-- SUBSCRIPTION -->
        <div class="order-item" *ngIf="subscription">
          <div class="row">
            <div class="col col-3">
              <div class="book">Membership</div>
            </div>
            <div class="col col-9">
              <div class="flex line-content">
                <div class="card-badge gold gold-background">
                  <div class="wwm-icon"></div>
                  Gold
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="row">
            <div class="col col-3">
              <div>Price</div>
            </div>
            <div class="col col-9">
              <div class="flex line-content">
                {{ subscription.item.paymentAmount | currency:'USD':true:'1.2-2' }}
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="row">
            <div class="col col-3">Renewal</div>
            <div class="col col-9 line-content">
              {{ subscriptionRenewal }}
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="footer">
      <div class="flex" [class]="{'column': !user}">
        <button *ngIf="user" class="btn invert" (click)="promotions()">
          My Promotions List
        </button>
        <button class="btn" (click)="startOver()">
          Make Another Purchase
        </button>
      </div>
      <div class="help">
        <a href="https://www.writtenwordmedia.com/contact-us/" target="_blank">
          Questions about your order? We’ve heard them all! <span>Send us a message</span> and we’ll get right back to you!
        </a>
      </div>
    </div>
  </div>
  <app-member-benefit [orderPaymentAmount]="orderTotal" [hasEvent]="hasEvent"></app-member-benefit>
  <div class="clear"></div>
</section>
